import React from "react";
import img1 from "../images/Dhoti.1.jpg";
import img2 from "../images/Dhoti.2.png";
import img3 from "../images/Dhoti.3.png";
import img4 from "../images/Dhoti.4.png";

const Dhoti = () => {
  return (
    <div className="mt-10">
      <h1 className="font-abhaya text-lg md:text-2xl 2xl:text-2xl 4xl:text-4xl 8xl:text-5xl 9xl:text-6xl 10xl:text-7xl 11xl:text-8xl text-center font-bold text-secondary tracking-[4px] 3xl:tracking-[7px] 8xl:tracking-[9px] mb-4 mt-5 8xl:mt-9">
        Pattu Dhoti
      </h1>
      <div className="grid grid-cols-2 2xl:grid-cols-4 gap-4 px-4 lg:px-10 3xl:px-12  3xl:gap-7 7xl:px-24  justify-center">
        {[{ img: img1, title: "Pattu Dhoti", brand: `4 Mulam `}, { img: img2, title: "Pattu Dhoti", brand: `8 Mulam ` }, { img: img3, title: "Sandal Pure", brand: `Silk Dhoti` }, { img: img4, title: "Pure Pattu", brand: `Thundu` }].map((item, index) => (
          <div key={index} className="relative flex flex-col items-center">
            <div className="relative w-full">
              <img className="w-full aspect-[3/4] object-cover rounded-lg" src={item.img} alt="Occasion" />
              <a
                href={`https://wa.me/919363799534?text=I'm%20interested%20in%20${encodeURIComponent(item.title +' - ' + item.brand)}`}
                target="_blank"
                rel="noopener noreferrer"
                 
              className=" absolute w-20 font-Belanosima py-1 3xl:py-2 8xl:py-2 sm:w-24 md:w-28 8xl:w-40 9xl:w-44 10xl:w-60 11xl:w-[400px] bg-[#000] bg-opacity-55 bg-[linear-gradient(189.61deg,_rgba(255,255,255,0)_-15.76%,_rgba(0,0,0,0.4)_60.33%)] bottom-4 9xl:bottom-7 11xl:bottom-9 left-1/2 transform -translate-x-1/2  font-semibold  text-[#f4a420] border-2 border-[#f4a420] rounded-lg 3xs:px-[3px] text-[9px]  2xs:text-[12px] xs:px-[4px]  xs:text-[13px]  md:px-3 sm:text-[17px] xl:px-3 xl:text-[18px] 2xl:px-[7px]  2xl:text-[16px] 3xl:text-[13px]  4xl:py-[2px] 4xl:text-[15px] 4xl:border-[3px] 5xl:text-[17px] 7xl:px-3 7xl:text-[19px] 8xl:px-4 8xl:text-[25px] 9xl:px-5 9xl:text-[30px] 10xl:border-[7px] 10xl:px-8 10xl:text-[38px] 11xl:px-10 11xl:text-[57px] text-center transition-all duration-200"
              >
                Buy now
              </a>
            </div>
            <h2 className="text-center mt-3 font-bellefair text-lg 2xl:text-xl 5xl:text-2xl 9xl:text-4xl 10xl:text-5xl 11xl:7xl">{item.title}</h2>
            <p className="text-center mt-1 font-bellefair text-md 2xl:text-lg 5xl:text-xl 9xl:text-3xl 10xl:4xl">{item.brand}</p>
          </div>
        ))}
      </div>
    </div>
  );
};


export default Dhoti;
